import { User as SupabaseUser } from '@supabase/supabase-js';

// DirectusUser, DirectusUserProfile のインポートを削除（Supabase認証のみに移行）

export interface User {
  id: string;
  email: string;
  username?: string;
  avatar_url?: string;
  email_confirmed_at?: string;
  // directusUser?: DirectusUser; // 削除
  // userProfile?: DirectusUserProfile; // 削除
  app_metadata?: { provider?: string };
  user_metadata?: { [key: string]: any };
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  errorDetails?: AuthError | null; // エラーの詳細情報を別途保存
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterCredentials {
  email: string;
  password: string;
  username: string;
  confirmPassword?: string; // オプショナルフィールドとして追加
}

export interface ResetPasswordData {
  email: string;
}

export type SocialProvider = 'google' | 'apple' | 'twitter';

export enum AuthErrorType {
  INVALID_CREDENTIALS = 'invalid_credentials',
  EMAIL_NOT_CONFIRMED = 'email_not_confirmed',
  USER_NOT_FOUND = 'user_not_found',
  WEAK_PASSWORD = 'weak_password',
  EMAIL_ALREADY_EXISTS = 'email_already_exists',
  USER_ALREADY_EXISTS = 'user_already_exists',
  SOCIAL_LOGIN_ERROR = 'social_login_error',
  SOCIAL_ACCOUNT_LINKING_ERROR = 'social_account_linking_error',
  NETWORK_ERROR = 'network_error',
  EMAIL_SEND_FAILURE = 'email_send_failure',
  USER_SYNC_ERROR = 'user_sync_error',
  UNKNOWN_ERROR = 'unknown_error',
}

export interface AuthError {
  type: AuthErrorType;
  message: string;
  details?: any;
}

export const mapSupabaseUserToUser = (supabaseUser: SupabaseUser): User => ({
  id: supabaseUser.id,
  email: supabaseUser.email || '',
  username: supabaseUser.user_metadata?.username,
  avatar_url: supabaseUser.user_metadata?.avatar_url,
  email_confirmed_at: supabaseUser.email_confirmed_at,
});
